import { render, staticRenderFns } from "./AmortizationTransactionTypeModals.vue?vue&type=template&id=b5ac6b02&"
import script from "./AmortizationTransactionTypeModals.vue?vue&type=script&lang=ts&"
export * from "./AmortizationTransactionTypeModals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5ac6b02')) {
      api.createRecord('b5ac6b02', component.options)
    } else {
      api.reload('b5ac6b02', component.options)
    }
    module.hot.accept("./AmortizationTransactionTypeModals.vue?vue&type=template&id=b5ac6b02&", function () {
      api.rerender('b5ac6b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Amortization/AmortizationTransactionTypeModals.vue"
export default component.exports